import React, {useEffect, useState} from 'react';
import {BackgroundReefResorts} from './style';
import {DateRangePickerComponent} from '@syncfusion/ej2-react-calendars';
import {DropDownListComponent} from '@syncfusion/ej2-react-dropdowns';

import '@syncfusion/ej2-base/styles/bootstrap4.css';
import '@syncfusion/ej2-buttons/styles/bootstrap4.css';
import '@syncfusion/ej2-calendars/styles/bootstrap4.css';
import '@syncfusion/ej2-dropdowns/styles/bootstrap4.css';
import '@syncfusion/ej2-inputs/styles/bootstrap4.css';
import '@syncfusion/ej2-popups/styles/bootstrap4.css';
import {useDispatch} from "react-redux";
import {finishLoading, showNavBar, startLoading} from "../../_store/_actions/uiActions";
import HttpClient from "../../_services/httpClient";
import DisplayRooms from "./DisplayRooms";

const ReefResorts = () => {
    const dispatch = useDispatch();
    const [hoteles, setHoteles] = useState([]);
    const [rooms, setRooms] = useState([]);
    const numChilds = [1,2,3,4,5,6,7,8,9,10];
    const numAdults = [1,2,3,4,5,6,7,8,9,10];
    const [currentHotel, setCurrentHotel] = useState({});

    const centerFields = {text: 'name', value: 'centerId'}

    const getData = (url) => {
        return new Promise((resolve, eject) => {
            dispatch(startLoading());
            HttpClient.get(url)
                .then(response => {
                    dispatch(finishLoading());
                    resolve(response);
                })
                .catch(error => {
                    dispatch(finishLoading());
                    eject(error);
                })
        });
    }

    const getCenter = () => {
        getData(`/center`).then(response => {
            if (response.status === 200) {
                setHoteles(response.data)
            }
        }).catch(error => {
        });
    }

    const getRooms = () => {
        getData('/room').then( response => {
           if (response.status === 200) {
               setRooms(response.data);
           }
        }).catch(error => {

        });
    }

    const displayRooms = () => {

    }


    const handleFindReservation = (e) => {
        e.preventDefault();
    }

    const handleSendReservation = (e) => {
        e.preventDefault();
    }

    useEffect(() => {
        dispatch(showNavBar());
        getCenter();
        getRooms();
    },[])

    return (
        <>
            <BackgroundReefResorts>

                <section id="page-title">
                    <div className="header pl-2">
                        <div className="title">
                            <div className="logo"></div>
                        </div>
                    </div>
                </section>

                <section id="booking">
                    <div className="col_five_sixth divcenter">
                        <div className="form-widget pt-3">
                            <form className="nobottommargin" id="template-contactform"
                                  onSubmit={handleFindReservation}
                                  name="template-contactform"
                            >
                                <div className="col_one_fourth">
                                    <label htmlFor="register-form-email">Hotel:</label>
                                    <DropDownListComponent id="hotel" dataSource={hoteles}
                                                           fields={centerFields}
                                                           placeholder="Select a Hotel" popupHeight="220px"/>
                                </div>
                                <div className="col_one_fourth">
                                    <label htmlFor="register-form-email">Booking date:</label>
                                    <div className='daterangepicker-control-section'>
                                        <DateRangePickerComponent placeholder="Select a Date" format="yyyy-MM-dd"></DateRangePickerComponent>
                                    </div>
                                </div>

                                <div className="col_half col_last">
                                    <div className="col_one_third">
                                        <label htmlFor="register-form-email">Adult:</label>
                                        <DropDownListComponent id="hotel" dataSource={numAdults}  placeholder="Adults" popupHeight="220px"/>
                                    </div>

                                    <div className="col_one_third">
                                        <label htmlFor="register-form-email">Child:</label>
                                        <DropDownListComponent id="hotel" dataSource={numChilds} placeholder="Children" popupHeight="220px"/>
                                    </div>

                                    <div className="col_one_third col_last">
                                        <div className="pt-3">
                                            <button name="submit" type="submit" id="submit-button" tabIndex="5"
                                                    value="Submit"
                                                    className="button button-3d">Find my Booking
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </section>

                <section id="detail">
                    <div className="container-fluid clearfix">
                        <div className="col_full pl-4">
                            <div className="postcontent sidebar nobottommargin clearfix">

                                <DisplayRooms rooms={rooms} />

                            </div>

                            <div className="sidebar sticky-sidebar-wrap nobottommargin col_last clearfix">
                                <div className="sidebar-widgets-wrap">
                                    <div className="sticky-sidebar">
                                        <div className="widget quick-contact-widget form-widget clearfix">
                                            <h4>Reserve Now!</h4>
                                            <form id="quick-contact-form" name="quick-contact-form"
                                                  onSubmit={handleSendReservation}
                                                  className="quick-contact-form"
                                            >
                                                <div className="form-process"></div>

                                                <input type="text"
                                                       className="required sm-form-control input-block-level pb-2"
                                                       id="quick-contact-form-name" name="quick-contact-form-name"
                                                       value="" placeholder="Full Name"/>
                                                <input type="text"
                                                       className="required sm-form-control email input-block-level pt-4"
                                                       id="quick-contact-form-email" name="quick-contact-form-email"
                                                       value="" placeholder="Email Address"/>
                                                <textarea
                                                    className="required sm-form-control input-block-level short-textarea pb-2"
                                                    id="quick-contact-form-message" name="quick-contact-form-message"
                                                    rows="4" cols="30" placeholder="Message"></textarea>
                                                <input type="text" className="hidden" id="quick-contact-form-botcheck"
                                                       name="quick-contact-form-botcheck" value=""/>

                                                <button type="submit" id="quick-contact-form-submit"
                                                        name="quick-contact-form-submit"
                                                        className="button button-small button-3d nomargin"
                                                        value="submit">Send Email
                                                </button>
                                            </form>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>


                </section>

            </BackgroundReefResorts>
        </>
    );
};

export default ReefResorts;
